<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-2 px-4"
      dense
      height="30"
    >
      <shortcut />
      <v-spacer />
      <!--      <v-toolbar-title> {{ $t('academyDashboard') }}</v-toolbar-title>-->
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row class="mx-0 mt-1 mb-3">
          <calender
            type-prop="category"
            height-prop="600"
          />
        </v-row>
      </v-container>
    </v-form>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Calender from './partial/calender'
  import Shortcut from './partial/shortcut'
  import Snakbar from '../../components/general/snakbar/snakbar'
  export default {
    name: 'AcademyDashboard',
    components: {
      Snakbar,
      Shortcut,
      Calender,
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      tag: null,
      render: false,
      isLoading: false,
      number: 1,
      menu2: null,
      menu1: null,
      duration: '01:00',
      startTime: '12:00',
      amount: null,
      sessionCount: null,
      teacherCost: null,
      teacher: null,
      start: null,
      end: null,
      events: null,
      category: null,
      place: null,
      days: null,
      daysList: null,
      checkNumber: null,
      startDate: null,
      name: null,
      valid: null,
      numberRules: [
        v => !!v || 'This field is required',
        v => (v && v >= 0) || 'The number must be bigger than zero',
      ],
      timer: 0,
      message: null,
      id: null,
      loading: false,
    }),
    watch: {
      snakbar () {
      },
      category (val, oldVal) {
        if (val) {
          if (!this.name) {
            this.name = val.name + '-' + this.number
          }
        }
        if (!this.tag && val.tags) {
          this.tag = val.tags
        }
      },
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
        this.getEventNumber()
      }
      this.daysList = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
    },
    mounted () {
    },
    methods: {
      allowedStep: m => m % 5 === 0,
      getDayNumber (day) {
        var number
        switch (day) {
          case 'Saturday':
            number = 1
            break
          case 'Sunday':
            number = 2
            break
          case 'Monday':
            number = 3
            break
          case 'Tuesday':
            number = 4
            break
          case 'Wednesday':
            number = 5
            break
          case 'Thursday':
            number = 6
            break
          case 'Friday':
            number = 7
            break
        }
        return number
      },
      review () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            checkEvent: 'active',
            name: app.name,
            days: app.days,
            startDate: app.startDate,
            startTime: app.startTime,
            duration: app.duration,
            sessionCount: app.sessionCount,
            teacher: app.teacher,
            teacherCost: app.teacherCost,
            color: app.colors[app.rnd(0, app.colors.length - 1)],
            place: app.place,
          },
        })
          .then(res => {
            res = res.data
            app.events = res
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'academyEvents', app.$data)
          .then(res => {
            // app.goTo('academyEventList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      getEventNumber () {
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              id: app.id,
              number: app.number,
              select: 'academyGetNumberEvent',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                if (app.checkNumber) {
                  app.snakbarText = res.message
                  app.snakbarColor = 'pink'
                  app.snakbar = true
                }
                app.number = res.number
              }
              app.checkNumber = true
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 50)
        this.loading = false
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academyEvents/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.name = res.name
              app.amount = res.amount
              app.number = res.number
              app.teacher = res.teacher
              app.teacherCost = res.teacher_cost
              app.place = res.place
              app.startDate = res.start_date
              app.startTime = res.start_time
              app.duration = res.duration
              app.duration = res.duration
              app.sessionCount = res.session_count
              app.category = res.category
              app.days = res.arrayDays
              app.tag = res.tags
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'academyEvents/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            // app.goTo('academyEventList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
